'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = function SvgIcon(_ref) {
	var icon = _ref.icon,
	    onClick = _ref.onClick,
	    className = _ref.className,
	    isCustom = _ref.isCustom;


	var href = '' + icon;

	if (!isCustom) {
		href = '#iconpress-icon-' + icon;
		className += ' ip-icon-' + icon + ' ';
	}

	return _react2.default.createElement(
		'svg',
		{ className: 'ip-icon ' + (className ? className : ''), 'aria-hidden': 'true', role: 'img', onClick: onClick },
		_react2.default.createElement('use', { href: href, xlinkHref: href })
	);
};

exports.default = SvgIcon;


//////////////////
// WEBPACK FOOTER
// ./src/components/SvgIcon.js
// module id = 3
// module chunks = 0 1